// TODO: Generalize for other channels
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Form from 'components/account_setup/shared_steps/Form';
import Table, { propTypes as tableProps } from 'components/molecules/Table';
import { toSnakeCase } from 'utilities/string';

const propTypes = {
  addMixpanelData: PropTypes.func.isRequired,
  formData: PropTypes.shape({
    id: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
  inputName: PropTypes.string.isRequired,
  keyFields: PropTypes.arrayOf(PropTypes.string).isRequired,
  table: PropTypes.shape({
    headers: tableProps.headers,
    rows: tableProps.rows,
  }).isRequired,
};

function getUniqueCount(rows, attribute) {
  return [...new Set(rows.map((row) => row.data[attribute].value))].length;
}

function Confirmation({
  addMixpanelData,
  formData,
  keyFields,
  inputName,
  table: {
    headers,
    rows: propRows,
  },
}) {
  useEffect(() => {
    addMixpanelData({
      totalAdAccounts: propRows.length,
      uniqueBrands: getUniqueCount(propRows, 'organizationBrandId'),
      uniqueMarkets: getUniqueCount(propRows, 'market'),
    });
  }, []);

  const generateKeyForRow = (row) => keyFields.map((key) => row.data[key]).join('_');

  const rows = propRows.map((propRow) => ({
    ...propRow,
    key: generateKeyForRow(propRow),
  }));

  // Handles the case where the form input name needs to be snakeCase for rails
  // but the keys are camelCase
  // Ex: organizationBrandId needs to be organization_brand_id as the input name
  const inputKeys = Object.keys(rows[0].data).map((key) => ({
    input: toSnakeCase(key),
    key,
  }));

  return (
    <>
      <Table
        headers={headers}
        rows={rows}
        title="Account Connections"
      />
      <Form
        formData={formData}
        inputKeys={inputKeys}
        inputName={inputName}
        items={rows.map((row) => row.data)}
      />
    </>
  );
}

Confirmation.propTypes = propTypes;

export default Confirmation;
